import Component 	from '../../colorz/Component';

import device 		from '../../colorz/utils/device';
import Easing 		from '../../colorz/utils/Easing';
import getData 		from '../../colorz/utils/getData';

module.exports = class Counter extends Component {
	onInit( el ) {
		this.el = el;

		this.from 	= parseInt( getData( this.el, 'from' ) );
		this.to 	= parseInt( getData( this.el, 'to' ) );
	}

	onReady() {
		this.easing = new Easing({
			type: 'easeOutQuint',
			duration: '3000',
			start: this.from - 1,
			end: this.to,
			callback: ()=>{
				this.isActive = false;
			}
		});
		this.easing.isActive = true;
	}

	onUpdate() {
		if (this.easing) {
			this.el.innerHTML = Math.ceil( this.easing.value );
		}
	}
}